import { put, takeEvery, all, fork } from "redux-saga/effects";
import { RoleDto } from "./../../../data/service-proxies";
import {
  createRoleCreatedAction,
  createRoleUpdatedAction,
} from "./../../actions/appData";
import { CRUD_CREATE_SUCCESS, Record, CRUD_UPDATE_SUCCESS } from "react-admin";
import resourceNames from "../../../data/resourceNames";

export function* roleCrudSaga() {
  yield all([onRoleCreateSaga, onRoleUpdateSaga].map(fork));
}

function* onRoleCreateSaga() {
  yield takeEvery(CRUD_CREATE_SUCCESS, handleRoleCreate);
}

function* onRoleUpdateSaga() {
  yield takeEvery(CRUD_UPDATE_SUCCESS, handleRoleUpdate);
}

function* handleRoleCreate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_ROLES) {
    return;
  }

  const createRequest = action.requestPayload.data as RoleDto;
  const createdRole = {
    ...createRequest,
    id: action.payload.data.id as string,
  };
  yield put(createRoleCreatedAction(createdRole));
}

function* handleRoleUpdate(action: {
  type: string;
  payload: { data: Record };
  requestPayload: { data: any };
  meta: { resource: string; fetchResponse: string };
}) {
  if (action.meta.resource !== resourceNames.ADMIN_ROLES) {
    return;
  }

  const updateRequest = action.payload.data as RoleDto;
  const updatedRole = {
    ...updateRequest,
  };
  yield put(createRoleUpdatedAction(updatedRole));
}
